import styled from 'styled-components'

import { OPTIMIZELY_EXPERIMENT_VARIATION_2 } from 'app-constants'
import PricingImage from 'assets/images/phones_hdpi.png'
import Button from 'components/Button'
import Layout from 'components/Layout'
import { Body, Heading, Title } from 'components/Typography'
import { style } from 'theme'

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 450px;
  text-align: center;
  margin: 30px auto;
`

export const Image = styled.div`
  height: 330px;
  width: 450px;
  background-image: url(${PricingImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40 8px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: 100%;
    background-size: 122.5%;
    height: calc(95vw - 60px);
  }
`

export const StyledHeading = styled(Heading)`
  font-weight: 600;
  margin-bottom: 10px;
`

export const StyledTitle = styled(Title)`
  font-weight: 600;
  margin-bottom: 6px;
  margin-top: 30px;
`

export const StyledBody = styled(Body)<{ variant?: string }>`
  max-width: ${props => (props.variant === OPTIMIZELY_EXPERIMENT_VARIATION_2 ? '300px' : '100%')};
  margin-bottom: 50px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 0px;
  }
`

export const FooterContainer = styled.div`
  font-size: 8px;
  line-height 14px;
  margin: 10px auto 0;
  text-align: center;

  color: ${style(theme => theme.colors.stone)};
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 340px;
  }
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const StyledButton = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-top: 18px;
    padding-bottom: 20px;
    background-color: white;
    position: sticky;
    bottom: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

export const StyledTextButton = styled(Button)`
  line-height: 22px;
  height: 22px;
  margin-top: 10px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 15px;
  }
`

export const LayoutNoMobilePadding = styled(Layout)`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 0px;
  }

  @media (max-width: 340px) {
    & div {
      padding: 0 5px;
    }
  }
`

export const Pill = styled.div`
  color: ${style(theme => theme.colors.white)};
  background-color: ${style(theme => theme.colors.purple)};
  border-radius: 50px;
  padding: 7px 11px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`
